import './ConfigurationJSONCreator.css';

import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import CustomButton from '../../b2b-common/CustomButton';
import { Add, Remove } from '@mui/icons-material';
import JSONPretty from 'react-json-pretty';
import { isEqual } from 'lodash';

const ConfigurationJSONCreator = ({ jsonConfig, setJsonConfig, isMasterConfiguration = true }) => {

    const [currentJsonConfig, setCurrentJsonConfig] = useState(jsonConfig);
    const [configurations, setConfigurations] = useState(
        jsonConfig ? Object.entries(jsonConfig).map(([key, value]) => ({ key, value })) : [{ key: '', value: '' }]
    );

    useEffect(() => {
        // console.log('ConfigurationJSONCreator useEffect jsonConfig:', jsonConfig);
        if (!isEqual(jsonConfig, currentJsonConfig)) {
            setCurrentJsonConfig(jsonConfig);
            setConfigurations(
                jsonConfig ? Object.entries(jsonConfig).map(([key, value]) => ({ key, value })) : [{ key: '', value: '' }]
            );
        }
    }, [jsonConfig]);

    useEffect(() => {
        if (!configurations) return;
        const newJsonConfig = configurations.reduce((acc, { key, value }) => {
            if (key) acc[key] = value;
            return acc;
        }, {});
        setJsonConfig(newJsonConfig);
    }, [configurations, setJsonConfig]);

    const handleAddPair = () => {
        setConfigurations([...configurations, { key: '', value: '' }]);
    };

    const handleRemovePair = (index) => {
        const newConfigurations = configurations.filter((_, i) => i !== index);
        setConfigurations(newConfigurations);
    };

    const handleKeyChange = (index, newKey) => {
        const newConfigurations = configurations.map((pair, i) =>
            i === index ? { ...pair, key: newKey } : pair
        );
        setConfigurations(newConfigurations);
    };

    const handleValueChange = (index, newValue) => {
        const newConfigurations = configurations.map((pair, i) =>
            i === index ? { ...pair, value: newValue } : pair
        );
        setConfigurations(newConfigurations);
    };

    // console.log('ConfigurationJSONCreator jsonConfig:', jsonConfig);

    return (
        configurations && (
            <div className='json-configuration'>
                {configurations.map((pair, index) => (
                    <div key={index} className='json-configuration-key-value'>
                        <TextField
                            variant='standard'
                            label="Key"
                            value={pair.key}
                            onChange={(e) => handleKeyChange(index, e.target.value)}
                            className='json-configuration-key'
                            InputProps={{
                                readOnly: !isMasterConfiguration
                            }}
                        />
                        <TextField
                            variant='standard'
                            label="Value"
                            value={pair.value}
                            onChange={(e) => handleValueChange(index, e.target.value)}
                            className='json-configuration-value'
                        />
                        {isMasterConfiguration &&
                            <CustomButton icon={<Remove />} tooltip={'Remove this key-value pair'}
                                onClick={() => handleRemovePair(index)}
                                className='json-configuration-remove-button'
                            />
                        }
                    </div>
                ))}
                {isMasterConfiguration &&
                    <CustomButton icon={<Add />} tooltip={'Add a new key-value pair'} onClick={handleAddPair}
                        className='json-configuration-add-button'
                    />
                }
                <JSONPretty id="json-pretty" data={JSON.stringify(currentJsonConfig, null, 2)}
                    className='json-config-pretty'
                />
            </div>
        )
    );
};

export default ConfigurationJSONCreator;